export class EntraRestoreReportEntity {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "EntraRestoreReportEntityEntityTypeEnum",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "userPrincipalName",
            "baseName": "userPrincipalName",
            "type": "string",
            "format": ""
        },
        {
            "name": "objectId",
            "baseName": "objectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "previousObjectId",
            "baseName": "previousObjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "outcome",
            "baseName": "outcome",
            "type": "EntraRestoreReportEntityOutcomeEnum",
            "format": ""
        },
        {
            "name": "objectIdPreserved",
            "baseName": "objectIdPreserved",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "relationships",
            "baseName": "relationships",
            "type": "EntraRestoreReportEntityRelationships",
            "format": ""
        },
        {
            "name": "requiredActions",
            "baseName": "requiredActions",
            "type": "Array<EntraRestoreReportEntityRequiredActionsInner>",
            "format": ""
        },
        {
            "name": "notes",
            "baseName": "notes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreReportEntity.attributeTypeMap;
    }
    constructor() {
    }
}
export var EntraRestoreReportEntityEntityTypeEnum;
(function (EntraRestoreReportEntityEntityTypeEnum) {
    EntraRestoreReportEntityEntityTypeEnum["User"] = "user";
    EntraRestoreReportEntityEntityTypeEnum["Group"] = "group";
})(EntraRestoreReportEntityEntityTypeEnum || (EntraRestoreReportEntityEntityTypeEnum = {}));
export var EntraRestoreReportEntityOutcomeEnum;
(function (EntraRestoreReportEntityOutcomeEnum) {
    EntraRestoreReportEntityOutcomeEnum["RecoveredFromRecycleBin"] = "RECOVERED_FROM_RECYCLE_BIN";
    EntraRestoreReportEntityOutcomeEnum["Recreated"] = "RECREATED";
    EntraRestoreReportEntityOutcomeEnum["SkippedAlreadyExists"] = "SKIPPED_ALREADY_EXISTS";
    EntraRestoreReportEntityOutcomeEnum["Failed"] = "FAILED";
})(EntraRestoreReportEntityOutcomeEnum || (EntraRestoreReportEntityOutcomeEnum = {}));
